import { render, staticRenderFns } from "./snakesbiology.vue?vue&type=template&id=f381d686&scoped=true&"
import script from "./snakesbiology.vue?vue&type=script&lang=js&"
export * from "./snakesbiology.vue?vue&type=script&lang=js&"
import style0 from "./snakesbiology.vue?vue&type=style&index=0&id=f381d686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f381d686",
  null
  
)

export default component.exports